import {PORTRAIT_POLICY, safeImageUrl} from "./portrait-policy.js";

// The catalogue contains metadata, never image bytes. Hash-addressed shards
// keep the application bundle small and allow a viewport-only working set.
export const portraitShard = qid => (Number(qid.slice(1)) % 128).toString(16).padStart(2,"0");
export function createCatalogLoader(fallback, {base = typeof __PORTRAIT_CATALOG__ === "undefined" ? null : __PORTRAIT_CATALOG__, fetcher = fetch, limit = 8, byteLimit = 2*1024*1024} = {}) {
  const shards = new Map(); let bytes=0, unavailable=false;
  return async (person, {signal}={}) => {
    const qid=person.wikidataId;
    if(!base || unavailable || !/^Q[1-9]\d*$/.test(qid||""))return fallback(person,{signal});
    const shard=portraitShard(qid);
    let saved=shards.get(shard);
    if(!saved) {
      const response=await fetcher(`${base}/${shard}.json`,{signal,credentials:"omit"});
      if(response.status===404){unavailable=true;return fallback(person,{signal});}
      if(!response.ok)throw new Error("Portrait catalogue unavailable");
      // Bound both transport metadata and retained parsed-record payload.
      if(Number(response.headers.get("content-length"))>byteLimit)throw new Error("Oversized catalogue shard");
      const text=await response.text(),size=new TextEncoder().encode(text).length;
      if(size>byteLimit)throw new Error("Oversized catalogue shard");
      const data=JSON.parse(text);
      if(data.policy!==PORTRAIT_POLICY||!data.records)throw new Error("Invalid portrait catalogue");
      saved={data,bytes:size};
      // Concurrent loads of the same shard must not double-account bytes.
      bytes-=shards.get(shard)?.bytes||0;shards.delete(shard);
      while(shards.size>=limit||bytes+size>byteLimit){const [key,item]=shards.entries().next().value;shards.delete(key);bytes-=item.bytes;}
      shards.set(shard,saved);bytes+=size;
    } else {shards.delete(shard);shards.set(shard,saved);}
    const record=saved.data.records[qid];
    if(!record)return fallback(person,{signal}); // New people since the audit.
    if(record.qid!==qid || record.policy!==PORTRAIT_POLICY || !["ready","unavailable"].includes(record.status))throw new Error("Invalid catalogue identity");
    const checked=Date.parse(record.checkedAt);
    if(!Number.isFinite(checked)||Date.now()-checked>7*86400000)return fallback(person,{signal});
    if(record.status==="ready"&&(!safeImageUrl(record.imageUrl)||!record.license||!record.author))throw new Error("Invalid catalogue provenance");
    return {...record}; // Never attach decoded pixels to shared metadata.
  };
}
